// Stopgap for a real gap: the pincode gate (snippets/pincode-gate.liquid,
// snippets/cart-shipping-bar.liquid) only runs in the cart — it has no
// visibility into Shopify's checkout, so a customer could pass the
// Coimbatore check here and then enter a different shipping address at
// checkout. This can't be prevented from theme code (checkout runs on a
// separate, locked-down domain), so instead it writes the verified pincode
// as a cart attribute, which flows through to the order's "Additional
// details" in Shopify Admin — letting staff cross-check Fruits & Vegetables
// orders against the actual shipping address before fulfilling.
(function () {
  function syncCartAttribute(value, verified) {
    fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Pincode entered at cart': value || '',
          'Pincode serviceable (local delivery)': verified ? 'Yes' : 'No',
        },
      }),
    }).catch(function () {});
  }

  function syncFromStorage() {
    var value = window.localStorage.getItem('pincodeGateValue');
    if (!value) return;
    var verified = window.localStorage.getItem('pincodeGateVerified') === '1';
    syncCartAttribute(value, verified);
  }

  window.addEventListener('pincode-gate:change', function (event) {
    var detail = event.detail || {};
    syncCartAttribute(detail.value, detail.verified);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromStorage);
  } else {
    syncFromStorage();
  }
})();
